import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { User } from "../../Models/user.models";
import { fetchMe } from "../../Services/users/users.service";
import { UserRoleEnum, UserRole } from "../../Constants/userRole";

const initialState: User | null = null;

const fetchUser = createAsyncThunk("users/fetchUser", async () => {
  try {
    const user = await fetchMe();
    return user;
  } catch (error) {
    throw error;
  }
});

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.rejected, (state, action): any => {
        return null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        if (action.payload) {
          state = {
            ...action.payload,
            role: UserRole[action.payload?.role as UserRoleEnum],
          };
        }
        return state;
      });
  },
});
// export const { fetchUser } = userSlice.actions;
export { fetchUser };
export const userReducer = userSlice.reducer;
